import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Switch, List, Row, Col, Icon, Input, Form } from 'antd';
import arrayMove from 'array-move';

const defaultValues = {
    links: [{ url: 'https://www.barry-callebaut.com/en-US', title: 'Barry-Callebaut' }, { url: 'https://www.barry-callebaut.com/en-US', title: 'Barry-Callebaut' }],
    hideHeader : false,
    componentName : "Related links"
};

const Component = ({ links, hideHeader, componentName }) => {
    const renderListItem = item => {
        return (
            <List.Item className="relatedLink f-size-1-dot-1-em">
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                    <Row type="flex" justify="space-between" className="clickable">
                        <Col className="relatedLink-title" style={{ padding: 0 }}>
                            {item.title}
                        </Col>
                        <Col style={{ padding: 0 }}>
                            <Icon type="select" />
                        </Col>
                    </Row>
                </a>
            </List.Item>
        );
    };

    return <List className="relatedLinks" size="small" itemLayout="vertical" bordered header={hideHeader ? null: <div>{componentName ? componentName: "Related links"} </div>} dataSource={links} renderItem={renderListItem} />;
};
Component.defaultProps = {
    componentName: defaultValues.componentName,
    links: defaultValues.links,
    hideHeader: defaultValues.hideHeader
};

const EditForm = props => {
    const { getFieldDecorator, getFieldValue } = props.form;
    const [links, setLinks] = useState(props.links);    
    const [hideHeader] = useState(props.hideHeader);
    const [componentName, setComponentName] = useState(props.componentName);

    props.form.mapValuesToProps = values => {
        values.links = values.urls.map((url, i) => ({ url: url, title: values.titles[i] }));

        delete values.urls;
        delete values.titles;

        return values;
    };

    /* ~~~~ Event-handlers ~~~~ */
    const handleAddLink = e => {
        let newLink = links.concat({ url: '', title: '' });
        setLinks(newLink);
    };
    const handleRemoveLink = index => {
        let urlFields = getFieldValue('urls');
        let titleFields = getFieldValue('titles');

        let newLinks = urlFields.map((url, i) => ({ url: url, title: titleFields[i] }));
        newLinks.splice(index, 1);
        props.form.resetFields();

        setLinks(newLinks);
    };
    const handleMoveLinkDown = index => {
        let urlFields = getFieldValue('urls');
        let titleFields = getFieldValue('titles');

        if (index + 1 < urlFields.length) {
            const newLinks = urlFields.map((url, i) => ({ url: url, title: titleFields[i] }));
            props.form.resetFields();

            setLinks(arrayMove(newLinks, index, ++index));
        }
    };
    const handleMoveLinkUp = index => {
        if (index > 0) {
            let urlFields = getFieldValue('urls');
            let titleFields = getFieldValue('titles');

            const newLinks = urlFields.map((url, i) => ({ url: url, title: titleFields[i] }));
            props.form.resetFields();

            setLinks(arrayMove(newLinks, index, --index));
        }
    };

    const handleComponentNameChanged = e => {
        setComponentName(e.target.value);
    };

    /* ~~~~ Util-methods ~~~~ */
    const createFormItems = () => {
        return links.map((entry, index) => (
            <Row type="flex" justify="space-between" className="relatedLinksForm-item" key={index}>
                <Col span={22}>
                    <Form.Item required hasFeedback>
                        {getFieldDecorator(`urls[${index}]`, {
                            rules: [
                                {
                                    required: true,
                                    message: 'This field is required.'
                                }
                            ],
                            initialValue: entry.url
                        })(<Input placeholder="Url" />)}
                    </Form.Item>
                    <Form.Item required hasFeedback>
                        {getFieldDecorator(`titles[${index}]`, {
                            rules: [
                                {
                                    required: true,
                                    message: 'This field is required.'
                                }
                            ],
                            initialValue: entry.title
                        })(<Input placeholder="Title" />)}
                    </Form.Item>
                </Col>
                <Col span={2}>
                    <div className="relatedLinksForm-actions">
                        {links.length > 1 ? (
                            <React.Fragment>
                                <Icon type="minus-circle-o" className="clickable" title="https://www.barry-callebaut.com/en-USRemove related link" onClick={handleRemoveLink.bind(this, index)} />
                                <Icon type="up-circle" className="clickable" title="Move related link up" onClick={handleMoveLinkUp.bind(this, index)} />
                                <Icon type="down-circle" className="clickable" title="Move related link down" onClick={handleMoveLinkDown.bind(this, index)} />
                            </React.Fragment>
                        ) : null}
                        {links.length === index + 1 ? <Icon type="plus-circle-o" className="clickable" title="Add new related link" onClick={handleAddLink} /> : null}
                    </div>
                </Col>
            </Row>
        ));
    };

    return (
        <React.Fragment>
            <Row >
                <Col span={24} style={{padding:"0.5rem 0.25rem"}}>
                    <Form.Item hasFeedback label="Title">
                        {getFieldDecorator('componentName', {
                            rules: [
                                {
                                    required: true,
                                    message: 'This field is required.'
                                }
                            ],
                            initialValue: componentName
                        })(<Input name="componentName" placeholder="please enter a title." onChange={handleComponentNameChanged} />)}
                    </Form.Item>
                </Col>
            </Row>
            <Row >
                <Col span={6}>
                    <Form.Item label="Hide Header">
                        {getFieldDecorator(`hideHeader`, {
                            valuePropName: 'checked',
                            initialValue: hideHeader
                        })(<Switch checkedChildren="Yes" unCheckedChildren="No" />)}
                    </Form.Item>
                </Col>
            </Row>
            <label className="ant-form-item-required" title="Related links" style={{ marginBottom: '1rem', display: 'block' }}>
                Related links
            </label>
            {createFormItems()}
        </React.Fragment>
    );
};
EditForm.defaultProps = {
    componentName: defaultValues.componentName,
    links: defaultValues.links,
    hideHeader: defaultValues.hideHeader
};

const exportedComponent = connect(
    null,
    null
)(Component);

const exportedEditForm = connect(
    null,
    null
)(EditForm);

export { exportedComponent as Component, exportedEditForm as EditForm };
